






















import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import PathBreadcrumbs from 'components/presenter/item/PathBreadcrumbs.vue'
import api from 'src/assets/api/gql'
import ItemUpdate from 'src/graphql/item/ItemUpdate.gql'
import { Item, ItemType } from 'src/graphql/types'

@Component({
  components: {
  PathBreadcrumbs
  }
})
export default class ItemNameEditor extends Vue {
  ItemType = ItemType
  loading: boolean = false
  name = ''
  value = ''
  error = ''

  @Prop()
  readonly item!: Item

  @Watch('item', { immediate: true })
  init (item: Item) {
    this.value = this.name = item.name
  }

  async save (value: string) {
    const name = value.trim()
    this.value = value
    this.error = ''
    if (name) {
      if (name !== this.name) {
        this.loading = true
        try {
          await api.mutate({
            query: ItemUpdate,
            variables: { id: this.item.id, data: { name } }
          })
          this.name = name
          setTimeout(() => { this.loading = false }, 500)
        } catch (e) {
          this.loading = false
          this.error = this.$t('label.savingError').toString()
        }
      }
    } else {
      this.error = this.$t('item.edit.name.err').toString()
    }
  }
}
